import { render, staticRenderFns } from "./PazienteDeviceList.vue?vue&type=template&id=14467ec9"
import script from "./PazienteDeviceList.vue?vue&type=script&lang=js"
export * from "./PazienteDeviceList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports